module.exports = __webpack_public_path__ + "img/default.f065b10c.png";